import React from "react";
import dynamic from "../../Image/dynamic.jpg";
import mobile from "../../Image/mobile.jpg";
import risk from "../../Image/risk.jpg";
import technology from "../../Image/TECHNOLOGY.jpg";
import "./Why.css";

const Why = () => {
  const reasons = [
    {
      title: "Progressive Leadership",
      image: dynamic,
      content:
        "StanTech Solutions Ltd operates with a customer-first leadership structure designed to ensure accountability, responsiveness, and long-term trust. Our management team combines operational expertise with strategic planning, allowing us to resolve concerns quickly while continuously improving service delivery through client feedback and industry best practices."
    },
    {
      title: "Seamless Mobile Integration",
      image: mobile,
      content:
        "Technology plays a critical role in how we operate. Our mobile-enabled systems provide real-time visibility into property visits, timestamps, and photo documentation. Clients receive the same updates simultaneously, enabling faster decisions, improved transparency, and immediate awareness of on-site activity."
    },
    {
      title: "Strategic Risk Management",
      image: risk,
      content:
        "We protect your assets through comprehensive insurance coverage, disciplined preservation practices, and proactive maintenance strategies. By applying data-driven risk analysis, we identify vulnerabilities early and implement measures that safeguard both property value and owner reputation."
    },
    {
      title: "Technology & Innovation",
      image: technology,
      content:
        "Our operations are powered by modern software that automates inspections, work orders, reporting, and documentation. Continuous system upgrades allow us to improve field productivity, accuracy, and turnaround times—ensuring clients always have reliable, up-to-date information."
    }
  ];

  return (
    <section id="Why" className="why-wrapper">
      <header className="why-header">
        <h1>Why StanTech Solutions Ltd</h1>
        <span className="why-divider"></span>
        <p>
          A disciplined approach to leadership, technology, and risk—built to
          protect your assets and simplify property maintenance.
        </p>
      </header>

      <div className="why-timeline">
        {reasons.map((item, index) => (
          <div className="why-entry" key={index}>
            <div className="why-marker">
              <span>{index + 1}</span>
            </div>

            <div className="why-content">
              <h2>{item.title}</h2>
              <p>{item.content}</p>
            </div>

            <div className="why-visual">
              <img src={item.image} alt={item.title} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Why;
